//const IMAGES_PATH = '/assets/images';
const SVG_PATH = '/assets/svg';

export const home = `${SVG_PATH}/home.svg`;

export const logo = `${SVG_PATH}/logo.svg`;
const IMAGES_PATH = '/assets/images';
export const checkboxMarkedCircle = `${SVG_PATH}/checkbox-marked-circle.svg`;
export const chevronRightCircleOutlined = `${SVG_PATH}/chevron-right-circle-outlined.svg`;
export const add = `${SVG_PATH}/add.svg`;
export const plus = `${SVG_PATH}/plus.svg`;
export const camCancelled = `${SVG_PATH}/cam-canceled.svg`;
export const micCancelled = `${SVG_PATH}/mic-cancelled.svg`;
export const camOpened = `${SVG_PATH}/camera-open.svg`;
export const micOpen = `${SVG_PATH}/mic-open.svg`;
export const addWhite = `${SVG_PATH}/addWhite.svg`;
export const down = `${SVG_PATH}/down.svg`;
export const google = `${SVG_PATH}/google.svg`;
export const linkedLogo = `${SVG_PATH}/linked-in-logo.svg`;
export const googleLogo = `${SVG_PATH}/google-logo.svg`;
export const outlook = `${SVG_PATH}/outlook.svg`;
export const yahoo = `${SVG_PATH}/yahoo.svg`;
export const aoi = `${SVG_PATH}/aoi.svg`;
export const menu = `${SVG_PATH}/menu.svg`;
export const menuWhite = `${SVG_PATH}/menuWhite.svg`;
export const menuBlack = `${SVG_PATH}/menuBlack.svg`;
export const mic = `${SVG_PATH}/mic.svg`;
export const microphone = `${SVG_PATH}/microphone.svg`;
export const more = `${SVG_PATH}/more.svg`;
export const mailUs = `${SVG_PATH}/mailUs.svg`;
export const notifications = `${SVG_PATH}/notifications.svg`;
export const eye = `${IMAGES_PATH}/eye.png`;
export const eyeSplash = `${IMAGES_PATH}/eye-splash.png`;
export const loadingBar = `${SVG_PATH}/loadingBar.svg`;
export const back = `${SVG_PATH}/back.svg`;
export const call = `${SVG_PATH}/call.svg`;
export const star = `${SVG_PATH}/star.svg`;
export const value = `${SVG_PATH}/value.svg`;
export const video = `${SVG_PATH}/video.svg`;
export const truck = `${SVG_PATH}/truck.svg`;
export const card = `${SVG_PATH}/card.svg`;
export const chat = `${SVG_PATH}/chat.svg`;
export const chatUs = `${SVG_PATH}/chatUs.svg`;
export const cancel = `${SVG_PATH}/cancel.svg`;
export const cancelGreen = `${SVG_PATH}/cancelGreen.svg`;
export const download = `${SVG_PATH}/download.svg`;
export const leftArrowPrimary = `${SVG_PATH}/left-arrow_primary.svg`;
export const leftArrowBlack = `${SVG_PATH}/left-arrow-black.svg`;
export const rightPrimary = `${SVG_PATH}/rightPrimary.svg`;
export const rightArrowPrimary = `${SVG_PATH}/right-arrow_prymary.svg`;
export const search = `${SVG_PATH}/search.svg`;
export const searchDept = `${SVG_PATH}/searchDept.svg`;
export const share = `${SVG_PATH}/share.svg`;
export const secure = `${SVG_PATH}/secure.svg`;
export const start = `${SVG_PATH}/start.svg`;
export const help = `${SVG_PATH}/help.svg`;
export const moon = `${SVG_PATH}/moon.svg`;
export const world = `${SVG_PATH}/world.svg`;
export const enveloppe = `${SVG_PATH}/enveloppe.svg`;
export const arrowRightWhite = `${SVG_PATH}/arrow_right_white.svg`;

export const events = `${SVG_PATH}/events.svg`;
export const destination = `${SVG_PATH}/destination.svg`;
export const record = `${SVG_PATH}/record.svg`;
export const refer = `${SVG_PATH}/refer.svg`;
export const settings = `${SVG_PATH}/settings.svg`;
export const buttonPlay = `${SVG_PATH}/button_play.svg`;
export const close = `${SVG_PATH}/close.svg`;
export const fullScreen = `${SVG_PATH}/full_screen.svg`;

export const homePrimary = `${SVG_PATH}/homePrimary.svg`;
export const eventsPrimary = `${SVG_PATH}/eventsPrimary.svg`;
export const destinationPrimary = `${SVG_PATH}/destinationPrimary.svg`;
export const recordPrimary = `${SVG_PATH}/recordPrimary.svg`;
export const referPrimary = `${SVG_PATH}/referPrimary.svg`;
export const settingsPrimary = `${SVG_PATH}/settingsPrimary.svg`;

export const payPal = `${SVG_PATH}/pay_pal.svg`;
export const creditCard = `${SVG_PATH}/credit_card.svg`;
export const googlePay = `${SVG_PATH}/google_pay.svg`;

export const facebook = `${SVG_PATH}/facebook.svg`;
export const twitter = `${SVG_PATH}/twitter.svg`;
export const youtube = `${SVG_PATH}/youtube.svg`;
export const whatsapp = `${SVG_PATH}/whatsapp.svg`;
export const linkedin = `${SVG_PATH}/linkedin.svg`;
export const gmail = `${SVG_PATH}/gmail.svg`;
export const instagram = `${SVG_PATH}/instagram.svg`;
export const facebookDark = `${SVG_PATH}/facebook_dark.svg`;
export const twitterDark = `${SVG_PATH}/twitter_dark.svg`;
export const instagramDark = `${SVG_PATH}/instagram_dark.svg`;
export const linkedinDark = `${SVG_PATH}/linkedin_dark.svg`;
export const youtubeDark = `${SVG_PATH}/youtube_dark.svg`;

export const referFriend = `${SVG_PATH}/referFriend.svg`;
export const addUser = `${SVG_PATH}/addUser.svg`;
export const upgrade = `${SVG_PATH}/upgrade.svg`;
export const priceRibbon = `${SVG_PATH}/priceRibbon.svg`;

export const flagFrance = `${SVG_PATH}/flag_france.svg`;
export const flagGerman = `${SVG_PATH}/flag_german.svg`;
export const flagUnitedKingdom = `${SVG_PATH}/flag_united_kingdom.svg`;
export const flagPanAfrican = `${SVG_PATH}/flag_pan_african.svg`;

export const map = `${SVG_PATH}/map.svg`;
